'use strict';
Object.defineProperty(exports, '__esModule', {
  value: true
});
var prefix = 'fas';
var iconName = 'file-edit';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = '';
var svgPathData = 'M286.102,445.202c-3.79,5.357-9.339,9.248-15.666,10.996l-31.467,8.594c-2.47,0.699-5.019,1.06-7.59,1.06 c-5.797,0-11.403-1.771-16.128-5.098c-6.936-4.827-11.29-12.44-11.978-20.685l-2.763-32.493c-0.654-6.666,1.139-13.342,4.929-18.711 l1.162-1.669H94.357c-9.057,0-16.399-7.466-16.399-16.5c0-9.068,7.342-16.534,16.399-16.534h135.86l30.362-43.366H94.357 c-9.057,0-16.399-7.466-16.399-16.523c0-9.057,7.342-16.523,16.399-16.523l189.602-0.485l71.099-101.946V99.833 c0-12.406-9.598-22.422-21.97-22.422h-54.43v43.072c0,20.335-16.624,36.418-36.926,36.418H132.264 c-20.346,0-36.396-16.094-36.396-36.418V77.411H40.852c-12.395,0-22.422,10.027-22.422,22.422v385.193 c0,12.406,10.038,22.974,22.422,22.974h292.213c12.406,0,21.982-10.579,21.982-22.974V347.293L286.102,445.202z M94.357,201.328 h185.237c9.034,0,16.388,7.455,16.388,16.512c0,9.057-7.354,16.523-16.388,16.523H94.357c-9.057,0-16.399-7.466-16.399-16.523 C77.958,208.783,85.301,201.328,94.357,201.328z M132.569,135.236h109.367c8.278,0,15.012-6.722,15.012-15.023v-62.9 c0-8.301-6.733-15.023-15.012-15.023h-16.478C225.345,21.143,208.157,4,186.964,4c-21.203,0-38.369,17.132-38.493,38.29h-15.903 c-8.301,0-15.012,6.722-15.012,15.023v62.889C117.557,128.503,124.268,135.236,132.569,135.236z M186.976,25.328 c9.417,0,17.053,7.579,17.155,16.974h-34.343C169.9,32.907,177.547,25.328,186.976,25.328z M491.652,113.198L297.651,391.347 l-44.809-31.253L446.82,81.934c2.041-2.966,5.369-4.545,8.707-4.545c2.098,0,4.229,0.62,6.079,1.917l27.384,19.083 c2.323,1.624,3.914,4.072,4.421,6.869C493.896,108.032,493.253,110.886,491.652,113.198z M223.36,401.351l11.876-17.03 l44.843,31.264l-11.876,17.03c-0.857,1.207-2.098,2.087-3.53,2.481l-31.636,8.662c-0.541,0.158-1.105,0.237-1.658,0.237 c-1.263,0-2.538-0.429-3.62-1.173c-1.523-1.083-2.526-2.763-2.662-4.647l-2.808-32.662 C222.131,404.035,222.525,402.558,223.36,401.351z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]
};

exports.sFileEdit = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;